import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const CriticalAlertSettings = ({ preferences, onUpdate }) => {
  const severityOptions = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'critical', label: 'Critical Only' },
  ];

  const alertTypes = [
    {
      key: 'taskDeadlines',
      label: 'Task Deadlines',
      description: 'Get notified when tasks are approaching their due date',
      icon: 'Clock',
    },
    {
      key: 'subscriptionChanges',
      label: 'Subscription Changes',
      description: 'Alerts for billing, plan changes, and subscription updates',
      icon: 'CreditCard',
    },
    {
      key: 'agentErrors',
      label: 'Agent Errors',
      description: 'Immediate notification when agents encounter errors or failures',
      icon: 'AlertTriangle',
    },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="AlertCircle" size={20} className="text-primary" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-foreground">Critical Alert Settings</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Configure which critical events trigger immediate notifications.
          </p>
        </div>
      </div>
      <div className="space-y-6">
        {/* Alert Types */}
        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">Alert Types</label>
          {alertTypes?.map((alert) => (
            <div key={alert?.key} className="flex items-start gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors">
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-1">
                <Icon name={alert?.icon} size={16} className="text-primary" />
              </div>
              <div className="flex-1">
                <Checkbox
                  checked={preferences?.[alert?.key] || false}
                  onChange={(e) => onUpdate({ [alert?.key]: e?.target?.checked })}
                  label={alert?.label}
                  description={alert?.description}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Severity Level */}
        <div>
          <Select
            label="Minimum Severity Level"
            options={severityOptions}
            value={preferences?.severityLevel || 'high'}
            onChange={(value) => onUpdate({ severityLevel: value })}
            description="Only send alerts at or above this severity level"
          />
        </div>

        {/* Alert Behavior Notice */}
        <div className="bg-muted/50 rounded-lg p-4 flex items-start gap-3">
          <Icon name="Zap" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
          <div className="text-xs text-muted-foreground">
            <p className="font-medium mb-1">Critical Alert Behavior</p>
            <p>
              Critical alerts bypass Do Not Disturb settings and are delivered immediately via all enabled
              channels (SMS, email, push). These alerts are reserved for time-sensitive issues requiring
              immediate attention.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CriticalAlertSettings;